import React from 'react';
import { fetchSuppliersForUser } from 'services/api/users';
import SuppliersTable from 'components/SuppliersTable';
import { addUserToSupplier, removeUserFromSupplier } from 'services';

const UserSuppliers = props => {
  const { userId } = props;

  return (
    <SuppliersTable
      userId={userId}
      entityKey={'userId'}
      entityName={'User'}
      addSupplierAPI={addUserToSupplier}
      deleteSupplierAPI={removeUserFromSupplier}
      fecthSuppliersAPI={fetchSuppliersForUser}
    />
  );
};

export default UserSuppliers;